import {IconInfoCircle} from '@tabler/icons-react';
import React from 'react';
import {Alert} from 'src/design/atoms/Alert';

export interface ClassroomOnlyBannerProps {
  canEdit: boolean;
}

/** Course Workspace state banner for a course with no contents, which only classroom close-out completes. */
export const ClassroomOnlyBanner: React.FC<ClassroomOnlyBannerProps> = ({
  canEdit,
}) => {
  let text =
    'This course has no content, so trainees cannot complete it online. Trainees complete it when a trainer closes out a class they attended, from the Classes tab.';
  if (canEdit) {
    text += ' To make it an online course, add content in the Build tab.';
  }

  return (
    <Alert
      icon={<IconInfoCircle />}
      title="Classroom-only course"
      color="blue"
      variant="light"
      mb="md"
      data-testid="classroom-only-banner">
      {text}
    </Alert>
  );
};
